interface YandexPayWidgetOptions {
  target: () => HTMLElement | null;
  amount: () => number;
  enabled: () => boolean;
  widgetType: 'Info' | 'BnplPreview';
}

export function useYandexPayWidget(options: YandexPayWidgetOptions) {
  const siteStore = useSiteStore();
  const { createYandexPaySession } = useYandexPay();
  const isLoading = ref(true);

  watch(
    [() => siteStore.isYandexPayReady, options.target, options.amount, options.enabled],
    async ([isReady, target, amount, enabled], _, onCleanup) => {
      let cancelled = false;
      let session: WtfishYandexPaySession | null = null;

      onCleanup(() => {
        cancelled = true;
        session?.destroy();
      });

      isLoading.value = true;
      if (!isReady || !target || !enabled) return;

      const createdSession = await createYandexPaySession(amount);
      // A new amount, closed modal or unmounted component can overtake SDK creation.
      if (cancelled) {
        createdSession?.destroy();
        return;
      }

      session = createdSession;
      try {
        session?.mountWidget(target, {
          widgetType: window.YaPay.WidgetType[options.widgetType],
          widgetTheme: window.YaPay.WidgetTheme.Light,
          borderRadius: 8,
        });
      } catch (error) {
        console.error(error);
        session?.destroy();
        session = null;
      } finally {
        isLoading.value = false;
      }
    },
    { immediate: true, flush: 'post' },
  );

  return { isLoading };
}
